export default {
  en: {
    loading: "Loading",
    phrases: [
      "Almost there...",
      "Just a moment...",
      "Getting things ready...",
    ],
  },
  es: {
    loading: "Cargando",
    phrases: [
      "Ya casi...",
      "Un momento...",
      "Preparando todo...",
    ],
  },
};
